import { CSSProperties, useEffect } from "react";

export function useSetBodyOverflowX(
  value: Exclude<CSSProperties["overflowX"], undefined>
): void {
  useEffect(() => {
    const original = window.document.body.style.overflowX;

    if (window) {
      window.document.body.style.overflowX = value;
    }

    return () => {
      window.document.body.style.overflowX = original;
    };
  }, [value]);
}
